exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.survey_banner_area[data-v-3a7050dd]{\n    width: 100%;\n    height: auto;\n    margin: 15px 0 15px 0;\n    display: flex;\n    justify-content: center ;\n}\n.banner_image[data-v-3a7050dd]{\n    width: 400px;\n    height: 100px;\n}\n.banner_image[data-v-3a7050dd]:hover {\n    border: 1px solid #ff9fae;\n    cursor: pointer;\n}\n", ""]);

// exports
